// extracted by mini-css-extract-plugin
export default {"orderDetailsContainer":"OrderDetails_orderDetailsContainer__OVAyI","orderDetailsContainerRow":"OrderDetails_orderDetailsContainerRow__WcQcI"};